import { render, staticRenderFns } from "./IdeaLibrary.vue?vue&type=template&id=0a2c00f9&scoped=true"
import script from "./IdeaLibrary.vue?vue&type=script&lang=js"
export * from "./IdeaLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c00f9",
  null
  
)

export default component.exports